module.exports = __webpack_public_path__ + "static/img/018_TO8_1479.4734c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/018_TO8_1479.jpg
// module id = /E6u
// module chunks = 0